import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";

const ConfirmationModal = React.memo((props) => {
  const { t } = useTranslation();
  return (
    <Modal
      showCloseIcon={true}
      classNames={{ modal: "modal-own confirm-modal-box", root: "modal-own-wrapper confirm-modal black-cross-btn-modal", closeButton: "confirm-close-btn" }}
      open={props.open}
      onClose={() => props.onCloseModal()}
      center
      closeOnOverlayClick={true}
    >
      <div className="video-player-wrapper px-2 text-center">
        {props.description && (
          <h3 className="font-20 primary-color py-3">{props.description}</h3>
        )}
        <div className="primary-color">
          {props?.deleteInfo && (
            <ul className="list-unstyled">
              {props?.deleteInfo?.map((data) => {
                return <li>{data}</li>;
              })}
            </ul>
          )}
        </div>
        <div className="border-bottom-own pt-2 mb-3"></div>
        <div className="pb-3 d-flex gap-3 justify-content-center w-full pt-3 ">
          <button
            type="button"
            onClick={() => props.onCloseModal(null)}
            className="btn secondary-btn mb-3 mb-md-0 full-width-xs-mb btn-own btn-own-grey min-height-btn min-width-btn-md mr-md-3"
          >
            {t("common.confirmModal.no")}
          </button>
          <button
            type="submit"
            onClick={() => props.onCloseModal(true)}
            className="btn primary-btn full-width-xs btn-own btn-own-primary min-height-btn min-width-btn-md"
          >
            {t("common.confirmModal.yes")}
          </button>
        </div>
      </div>
    </Modal>
  );
});

export default ConfirmationModal;
